var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#EEF4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1130_2148)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1130_2148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4291 11.9124H27.6913V17.7348C29.7445 17.9605 31.7128 18.6784 33.4291 19.8277V11.9124ZM24.8224 11.9124H19.0846V19.8277C20.8009 18.6784 22.7693 17.9605 24.8224 17.7348V11.9124ZM26.2569 40.6014C28.92 40.6014 31.474 39.5435 33.3571 37.6604C35.2401 35.7773 36.298 33.2233 36.298 30.5602C36.298 27.8972 35.2401 25.3432 33.3571 23.4601C31.474 21.577 28.92 20.5191 26.2569 20.5191C23.5938 20.5191 21.0398 21.577 19.1567 23.4601C17.2736 25.3432 16.2157 27.8972 16.2157 30.5602C16.2157 33.2233 17.2736 35.7773 19.1567 37.6604C21.0398 39.5435 23.5938 40.6014 26.2569 40.6014ZM24.4997 28.3813L26.2569 24.8224L28.0141 28.3813L31.9416 28.9508L29.1 31.7222L29.7713 35.6339L26.2569 33.7878L22.7439 35.6339L23.4152 31.7222L20.5736 28.9508L24.4997 28.3813Z",
    fill: "#1162FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1130_2148",
    x: 14.2157,
    y: 9.91235,
    width: 24.0824,
    height: 32.6891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1130_2148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1130_2148",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1130_2148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4269,
    height: 34.4269,
    fill: "white",
    transform: "translate(9.04346 9.04346)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/BadgeIcon.8efae1cc.svg";
export { ForwardRef as ReactComponent };